import { render } from "./SelectK2svForAvrModal.vue?vue&type=template&id=544ec56c&scoped=true"
import script from "./SelectK2svForAvrModal.vue?vue&type=script&lang=js"
export * from "./SelectK2svForAvrModal.vue?vue&type=script&lang=js"

import "./SelectK2svForAvrModal.vue?vue&type=style&index=0&id=544ec56c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-544ec56c"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QTable,QTd,QBtn});
